import { render, staticRenderFns } from "./direct-sales-dashboard.page.vue?vue&type=template&id=7817b006&scoped=true"
import script from "./direct-sales-dashboard.page.vue?vue&type=script&lang=ts"
export * from "./direct-sales-dashboard.page.vue?vue&type=script&lang=ts"
import style0 from "./direct-sales-dashboard.page.vue?vue&type=style&index=0&id=7817b006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7817b006",
  null
  
)

export default component.exports